<table class="search-instrument-driver-table-view-table w-100">
  <thead>
  <tr>
    <th
      *ngFor="let header of tableHeaders; let i = index"
      scope="col"
      [ngClass]="{
          'search-table-view-header': i < 2 && header.sortingField,
          'col-4': i === 0 && header.sortingField,
          'col-5': i === 1 && header.sortingField,
          'col-3': i > 1
        }"
    >
      <a *ngIf="header.sortingField" (click)="sortTable(header)">
        <div class="d-flex align-items-baseline">
          <span class="search-table-header-display-string me-3" [translate]="header.displayKey"></span>
          <svg-icon
            class="d-none d-xl-inline-block"
            [height]="18"
            [width]="11"
            [key]="header.currentOrder === 'asc' ? 'table-sort-desktop-asc' : 'table-sort-desktop-desc'"
          ></svg-icon>
          <svg-icon
            class="d-none d-sm-inline-block d-lg-none"
            [key]="header.currentOrder === 'asc' ? 'table-sort-tablet-asc' : 'table-sort-tablet-desc'"
          ></svg-icon>
          <svg-icon class="d-inline-block d-sm-none"
                    [key]="header.currentOrder === 'asc' ? 'table-sort-mobile-asc' : 'table-sort-mobile-desc'"
          ></svg-icon>
        </div>
      </a>
      <span
        class="search-table-header-display-string custom-position"
        [translate]="header.displayKey"
        *ngIf="!header.sortingField"
      ></span>
    </th>
  </tr>
  </thead>
  <tbody>
  <ng-container *ngFor="let searchResultEntry of getSearchResultList(); let odd = odd">
    <tr [class.table-row-odd]="odd">
      <td>
        <a href="{{ searchResultEntry.uri }}" [appResultClickTracking]="searchResultEntry">{{
            searchResultEntry.model
          }}</a>
      </td>
      <td>{{ searchResultEntry.manufacturerDisplay }}</td>
      <td class="search-instrument-driver-table-view-all-td">
        <a (click)="toggleDriverTable(searchResultEntry)">
            <span
              class="search-instrument-driver-table-view-all-text search-instrument-driver-table-button"
              [innerHTML]="searchResultEntry.viewOptionsString"
            ></span>
          <span *ngIf="searchResultEntry.isLoading" class="loader"></span>
          <svg-icon
            *ngIf="!searchResultEntry.isLoading"
            [key]="searchResultEntry.driversTableOpened ? 'arrow-up' : 'arrow-down'"
            width="24px"
            height="24px"
          ></svg-icon>
        </a>
      </td>
    </tr>
    <tr
      [class.table-row-odd]="odd"
      class="search-instrument-driver-table-view-inner-table-tr"
      *ngIf="searchResultEntry.driversTableOpened"
    >
      <td colspan="3">
        <table
          class="search-instrument-driver-table-view-inner-table"
          *ngIf="searchResultEntry.dataCompletionResponse?.result && !searchResultEntry.hasError"
        >
          <thead>
          <tr>
            <th class="col col-sm-4">{{ 'ade' | translate }}</th>
            <th class="col-6 col-sm-3">{{ 'driverType' | translate }}</th>
            <th class="col col-sm-2 search-instrument-driver-table-view-inner-table-third-header">
              {{ 'interfaces' | translate }}
            </th>
            <th class="col col-sm-3 d-none d-sm-block text-nowrap">{{ 'niCertified' | translate }}</th>
          </tr>
          </thead>
          <tbody>
          <ng-container *ngFor="let result of searchResultEntry.dataCompletionResponse?.result">
            <tr>
              <td>
                <a href="{{ result.uri }}" target="_blank" [appResultClickTracking]="searchResultEntry">{{
                    result.ade
                  }}</a>
              </td>
              <td>{{ result.driverType }}</td>
              <td>{{ result.interfaces }}</td>
              <td class="d-none d-sm-block">{{ result.niCertified }}</td>
            </tr>
            <tr class="d-table-row d-sm-none">
              <td colspan="3" class="search-instrument-driver-table-certified-mobile">
                    <span class="search-instrument-driver-table-certified-mobile-text">{{
                        'niCertifiedCamelCase' | translate
                      }}</span>
                <div class="search-instrument-driver-table-certified-mobile-svg-div">
                  <svg-icon [key]="result.niCertified ? 'check' : 'times'"></svg-icon>
                </div>
              </td>
            </tr>
          </ng-container>
          </tbody>
        </table>
        <span
          class="search-instrument-driver-mashup-drivers-error-table-mode"
          *ngIf="searchResultEntry.dataCompletionResponse?.error || searchResultEntry.hasError"
        >{{ 'noDriversFoundErrorMessage' | translate }}</span
        >
      </td>
    </tr>
  </ng-container>
  </tbody>
</table>
